import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useTranslation from '@/react/hooks/useTranslation';
import DatePicker, { registerLocale } from 'react-datepicker';
import { format } from 'date-fns';

// eslint-disable-next-line import/no-unresolved
import { de, enUS } from 'date-fns/locale';

registerLocale('de', de);

const TravelRange = ({ locale, onDateChanged }) => {
  const __ = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date;
  });
  const localizer = locale === 'de' ? de : enUS;

  const handleDateChange = dates => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    // close calendar when both dates are selected
    if (start && end) {
      setIsOpen(false);
      onDateChanged({ startDate: start, endDate: end });
    }
  };

  useEffect(() => {
    onDateChanged({ startDate, endDate });
  }, []);

  return (
    <div className='s-booking-panel__item'>
      <button
        className='s-booking-panel__item'
        type='button'
        title={__('booking-panel-select-travel-range')}
        aria-label={__('booking-panel-select-travel-range')}
        onClick={() => setIsOpen(!isOpen)}
      >
        <label className='s-booking-panel__item-label'>{__('booking-panel-travel-range')}</label>
        <p className='s-booking-panel__item-content'>
          {format(startDate, 'eeeeee. dd MMM', { locale: localizer })} -{' '}
          {endDate > startDate ? format(endDate, 'eeeeee. dd MMM', { locale: localizer }) : ''}
        </p>
      </button>
      <DatePicker
        calendarClassName={`s-booking-panel__calendar ${isOpen ? 'open' : ''}`}
        selected={startDate}
        onChange={handleDateChange}
        minDate={new Date()}
        startDate={startDate}
        endDate={endDate}
        locale={locale}
        inline
        selectsRange
      />
    </div>
  );
};

TravelRange.propTypes = {
  locale: PropTypes.string,
  onDateChanged: PropTypes.func
};

export default TravelRange;
